import { sendGoogleEvent } from '@html/_common/utils';

export default function initiateAskForm(eventCategory) {
  const buttonStickyBar = '.js-ao-tour-sticky-bar__cta--question';
  const buttonCtaBlock = '.js-ao-tour-start-planning-your-tour__cta-ask';
  const askForm = '#ask_popup';

  $(buttonStickyBar).on('click', () => {
    $(askForm).data('open-by', 'sticky-bar');
  });
  $(buttonCtaBlock).on('click', () => {
    $(askForm).data('open-by', 'cta-block');
  });

  $('.js-ao-common-ask-form__private-tour-type input').on('change', function trackingPrivate() {
    const openBy = $(askForm).data('open-by');
    const inputValue = $(this).val();
    if (inputValue === 'private') {
      sendGoogleEvent(
        eventCategory,
        'Personalized Form Interaction',
        openBy === 'sticky-bar' ? 'Ask a Question - Sticky bar' : 'AAQ',
      );
    }
  });
}
